<template>
    <div class="map-content">
        <div class="tips" v-if="isShow">
            <div class="tips_warp">
                <div class="tips_title">温馨提示!</div>
                <div>您未开启手机定位,请选择城市</div>
            </div>
        </div>
        <div id="container" class="case-map"></div>
        <div class="nav-column" v-if="arrNav.length!=0">
            <ul>
                <div class="nav_list" v-for="(item, index) in arrNav" :key="index">
                    <div class="line-nav" v-if="index != 0"></div>
                    <li :class="item.open ? item.className : ''" @click="navChange(index)">
                        <div :class="[item.iconName]"></div>
                        <div class="nav-text">
                            <p class="num">
                                <span>{{ item.oTotalNum }}</span>户
                            </p>
                            <p :class="`state-${index + 1}`">{{ item.name }}</p>
                        </div>
                    </li>
                </div>
                <!-- <div class="line-nav"></div>
                <li :class="[nActive === 2 ? 'active-2':'']" @click="navChange(2)">
                    <div class="nav-icon-2"></div>
                    <div class="nav-text">
                        <p class="num"><span>{{ oTotalNum.build_num }}</span>户</p>
                        <p class="state-2">施工中</p>
                    </div>
                </li>
                <div class="line-nav"></div>
                <li :class="[nActive === 3 ? 'active-3':'']" @click="navChange(3)">
                    <div class="nav-icon-3"></div>
                    <div class="nav-text">
                        <p class="num"><span>{{ oTotalNum.finish_num }}</span>户</p>
                        <p class="state-3">已完工</p>
                    </div>
                </li> -->
            </ul>
        </div>

        <!-- 案例列表 -->
        <div class="case-modal">
            <div class="case-modal-header" @click="openChange()">
                <div :class="[
                        'arrow-icon',
                        !bCaseModalShow ? 'arrow-icon-t' : '',
                    ]"></div>
            </div>
            <div :class="['case-list', bCaseModalShow ? 'upward' : 'downward']">
                <pull-to :distance-index="3" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG" :top-load-method="downRefresh" :bottom-load-method="upRefresh" :is-top-bounce="false" :is-bottom-bounce="false" bottom-block-height:50 top-block-height:50>
                    <ul v-if="arrPlotsDetail.length !== 0">
                        <li v-for="(item, index) in arrPlotsDetail" :key="index" @click="toDetail(item.id, item.images[0].img_url,item.pro_name,item.version)">
                            <p>
                                {{ item.type=="冷暖风水"?'智慧集成系统': item.type}}<span>|</span>{{
                                    item.city + item.community_name + "项目案例"
                                }}
                            </p>
                            <div class="attr">
                                <div class="attr-left">
                                    <p>{{ item.house_area }}</p>
                                    <p>{{ item.house_cate || "暂无" }}</p>
                                    <!-- <div class="tag-list">
                                        <div>{{ item.type }}</div>
                                    </div> -->
                                </div>
                                <div class="attr-right">
                                    <img src="@/assets/images/ant/map/watch.png" alt="" />
                                    <span>{{
                                        item.views || item.real_views
                                    }}</span>
                                </div>
                            </div>
                            <div class="pic-list" v-if="
                                    item.images.length &&
                                    item.images.length !== 0
                                ">
                                <div class="pic-item" v-for="(imgItem, imgIndex) in item.images" :key="imgIndex">
                                    <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2" />
                                </div>
                            </div>

                            <div :class="['state-icon', stateStyle(item.state)]"></div>
                        </li>
                        <!-- <li v-for="(item, index) in 10" :key="index">
                            <img src="@/assets/images/ant/map/img.png" alt="">
                            <div class="case-info">
                                <p class="case-name">南京仁恒翠竹园5栋</p>
                                <p class="attr"><span>208</span><span>大平层</span></p>
                                <p class="case-state">目前进度：2021年1月7日-系统打压完成</p>
                            </div>
                            <div class="tag wqy"></div>
                        </li> -->
                    </ul>
                    <div class="not-data" v-else>暂时还没有数据哦~</div>

                </pull-to>
            </div>
        </div>
    </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
import oStorage from '@/libsV2/storage.js';
import PullTo from "vue-pull-to";
import {getProjectPlots, getPlotsCase, getProjectPlotsV2,getPlotsCaseV2} from "@/js/map.js";
export default {
    name: "antMap",
    components: {
        PullTo,
    },
    data() {
        return {
            map: null, // 地图实列对象
            nActive: 1, // tab选中
            nLongitude: 121.254294, // 经度
            nLatitude: 31.330062, // 维度
            bCaseModalShow: false, // 地图与案例切换
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "上拉加载",
                triggerText: "释放更新",
                loadingText: "加载中...",
                doneText: "加载完成",
                failText: "加载失败",
                loadedStayTime: 400,
                stayDistance: 50,
                triggerDistance: 70,
            },
            arrPlotsDetail: [], // 小区里面的项目列表
            isShow: false ,// 没有传定位时显示提示
            objFourLngLat:{
                northWest:'',//'西北',
                southEast:'',//'东南',
            },//可视区域四个角的经纬度
        };
    },
    props: {
        longitude: {
            type: Number,
            defualt: null,
        },
        latitude: {
            type: Number,
            defualt: null,
        },
        oTotalNum: {
            type: Object,
            defualt: {},
        },
        arrNav: {
            type: Array,
            defualt: [],
        },
    },
    filters: {
        subTitle(value) {
            const index = value.lastIndexOf("栋");
            if (!~index) {
                return value;
            } else {
                return value.substring(0, index) + "栋";
            }
        },
    },
    created() {
        // this.initMap()
    },
    mounted() { },
    computed: {},
    watch: {
        longitude: {
            handler(newValue, oldValue) {
                if (newValue === undefined) {
                    this.isShow = true
                    setTimeout(() => {
                        this.isShow = false
                        this.$emit("openToast")
                    }, 1500)
                } else {
                    this.map = null;
                    this.nActive = 1;
                    this.isShow = false
                    this.initMap();
                }


            },
        },
    },
    methods: {
        // 进入详情
        toDetail(id, img,acc_id,version) {
            if(version == 1){
                // localStorage.setItem("detailImg", img);
                oStorage.setStorage("detailImg", img);
                this.$router.push({ path: "/antdetails/index", query: { id ,acc_id} });
            }else{
                // localStorage.setItem("detailImg", img);
                oStorage.setStorage("detailImg", img);
                this.$router.push({ path: "/project/detail/construction", query: { id ,acc_id} });
            }
        },
        // 列表右上角标签
        stateStyle(state) {
            let className = "";
            switch (Number(state)) {
                case 1:
                    className = "yqy";
                    break;
                case 2:
                    className = "sgz";
                    break;
                case 3:
                    className = "ywg";
                    break;
            }
            return className;
        },
        // 打开底部案例列表
        openChange() {
            this.bCaseModalShow = !this.bCaseModalShow;
        },
        // 下拉暂无使用
        downRefresh(loaded) {
            loaded("done");
        },
        // 上拉暂无使用
        upRefresh(loaded) {
            loaded("done");
        },
        // tab切换
        navChange(value) {
            let arrNumber = [];
            this.arrNav.forEach((it, index) => {
                if (value == index) {
                    it.open = !it.open;
                } else {
                    it.open = false
                }
                if (it.open == true) {
                    arrNumber.push(it.id);
                }
            });
            //  console.log(arrNumber.join(","));
            this.arrPlotsDetail = [];
            this.nActive = arrNumber.join(",");
            this.getProjectPlots();
        },
        // 初始化地图
        initMap() {
            const that = this;
            const { longitude, latitude } = this;
            MapLoader().then(
                (AMap) => {
                    //  console.log("地图加载成功");
                    this.map = new AMap.Map("container", {
                        center: [longitude, latitude],
                        expandZoomRange: true,
                        zoom: 10,
                        showIndoorMap: true, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                        resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                        dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                        keyboardEnable: true, //地图是否可通过键盘控制，默认为true
                        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
                        zoomEnable: true, //地图是否可缩放，默认值为true
                        rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                        draggable:true,
                        scrollWheel: true,
                    });
                    that.objFourLngLat.northWest = that.map.getBounds().getNorthWest()
                    that.objFourLngLat.southEast = that.map.getBounds().getSouthEast()
                    console.log(that.objFourLngLat,'可是区域经纬度')
                    let arrNumber = [];
                    this.arrNav.forEach((it) => {
                        if (it.open == true) {
                            arrNumber.push(it.id);
                        }
                    });
                    this.nActive = arrNumber.join(",");
                    that.map.on("complete", function () {
                        console.log('地图加载完成')
                        that.getProjectPlots(); // 获取小区标点数据
                    });
                    // 地图移动结束
                    that.map.on("moveend", function () {
                        // 获取iot总数
                        that.objFourLngLat.northWest = that.map.getBounds().getNorthWest()
                        that.objFourLngLat.southEast = that.map.getBounds().getSouthEast()
                        that.getProjectPlots(); // 获取小区标点数据
                    })
                },
                (e) => {
                    //  console.log("地图加载失败", e);
                }
            );
        },
        // 创建标注
        createMarker(data) {
            this.map.clearMap();
            const that = this;
            const arrMarker = data.map((item) => {
                let markerContent = null;
                if (Number(this.nActive) == 1) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_red.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (Number(this.nActive) == 2) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_violet.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (Number(this.nActive) == 3) {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_blue.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else {
                    markerContent =
                        '<div class="ant-map-marker">' +
                        '<img src="' +
                        require("@/assets/images/ant/map/icon_green.png") +
                        '">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                }
                const marker = new AMap.Marker({
                    position: new AMap.LngLat(
                        Number(item.longitude),
                        Number(item.latitude)
                    ),
                    content: markerContent,
                    offset: new AMap.Pixel(-13, -30),
                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });

                // 绑定点击事件
                marker.on("click", function ({ lat, lng, type, target }) {
                    // 当前标注变色
                    // target.setContent('<div class="custom-content-marker">' +
                    //                     '<img src='+ that.oIcon.iconYellow +'>' +
                    //                     '<div class="close-btn">' + item.topic_total + '</div>' +
                    //                 '</div>')
                    that.arrPlotsDetail = [];
                    that.bCaseModalShow = true;
                    // that.getPlotsDetail(item.id);
                    that.getPlotsDetail(item.plot_ids.join(','));
                });

                return marker;
            });

            // 当前位置标注
            let markerContentNow =
                '<div class="ant-map-marker">' +
                '<img src="' +
                require("@/assets/images/icon_yellow.png") +
                '">' +
                "</div>";
            let markerNow = new AMap.Marker({
                position: new AMap.LngLat(this.longitude, this.latitude),
                content: markerContentNow,
                offset: new AMap.Pixel(-13, -30),
                animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
            });
            arrMarker.push(markerNow);

            this.map.add(arrMarker);
        },
        // 获取小区
        async getProjectPlots() {
            const resquestData = {
                // longitude: this.longitude,
                // latitude: this.latitude,
                // longitude:'0',
                // latitude:'0',
                // distance: 500,
                state: this.nActive || 0,
                'lon-left-top':this.objFourLngLat.northWest.lng,
                'lat-left-top':this.objFourLngLat.northWest.lat,
                'lon-right-bottom':this.objFourLngLat.southEast.lng,
                'lat-right-bottom':this.objFourLngLat.southEast.lat,
            };
            const resultData = await getProjectPlotsV2(resquestData);
            if (resultData.data.data.result.list.length !== 0) {
                // 获取小区里面项目案例

                // this.getPlotsDetail(resultData.data.data.result.list[0].id);
                this.getPlotsDetail(resultData.data.data.result.list[0].plot_ids.join(','));
            }
            //  console.log(resultData.data.data.result.list);
            this.createMarker(resultData.data.data.result.list);
        },
        // 获取小区里面的项目
        async getPlotsDetail(id) {
            //getPlotsCase --v1版本参数plot_id
            //getPlotsCaseV2  --v2坂本 参数plot_ids
            const resultData = await getPlotsCaseV2({ plot_ids: id });
            //  console.log("小区项目数：", resultData.data.data.result.lists);
            this.arrPlotsDetail = [
                ...this.arrPlotsDetail,
                ...resultData.data.data.result.lists,
            ];
        },
    },
};getPlotsCaseV2
</script>

<style lang="scss" scoped>
.map-content {
    position: relative;
}
.case-map {
    width: 100%;
    height: 100vh;
}
.nav-column {
    width: 100%;
    position: absolute;
    top: 150px;
    left: 0;
    display: flex;
    justify-content: center;
    ul {
        border: 1px solid rgb(190, 201, 249);
        background-color: rgb(255, 255, 255);
        box-shadow: 0px 0px 60px 0px rgba(168, 183, 251, 0.8);
        height: 128px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 60px;
        padding: 0 15px;
        .nav_list {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        li {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 204px;
            padding: 15px 0;
            .nav-icon-1 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon1_s.png")
                    top/100% auto no-repeat;
            }
            .nav-icon-2 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon2_s.png")
                    top/100% auto no-repeat;
            }
            .nav-icon-3 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon3_s.png")
                    top/100% auto no-repeat;
            }
            .nav-text {
                .num {
                    font-size: 24px;
                    color: rgb(33, 50, 101);
                    span {
                        font-size: 32px;
                    }
                }
                .state-1 {
                    color: rgb(33, 50, 101);
                    font-size: 24px;
                    position: relative;
                    &::after {
                        display: inline-block;
                        content: "";
                        background-color: rgb(228, 96, 106);
                        position: absolute;
                        left: 0px;
                        bottom: -5px;
                        width: 66px;
                        height: 4px;
                    }
                }
                .state-2 {
                    color: rgb(33, 50, 101);
                    font-size: 24px;
                    position: relative;
                    &::after {
                        display: inline-block;
                        content: "";
                        background-color: rgb(167, 130, 236);
                        position: absolute;
                        left: 0px;
                        bottom: -5px;
                        width: 66px;
                        height: 4px;
                    }
                }
                .state-3 {
                    color: rgb(33, 50, 101);
                    font-size: 24px;
                    position: relative;
                    &::after {
                        display: inline-block;
                        content: "";
                        background-color: rgb(108, 133, 250);
                        position: absolute;
                        left: 0px;
                        bottom: -5px;
                        width: 66px;
                        height: 4px;
                    }
                }
            }
        }
        .line-nav {
            width: 2px;
            background-color: rgba(38, 50, 102, 0.4);
            height: 60px;
            margin: 0 15px;
        }
        .active-1 {
            border-radius: 55px;
            background-color: rgb(228, 96, 106);
            .nav-icon-1 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon1.png")
                    top/100% auto no-repeat;
            }
            .nav-text {
                .num {
                    color: #fff;
                }
                .state-1 {
                    color: #fff;
                    &::after {
                        display: none;
                    }
                }
            }
        }
        .active-2 {
            border-radius: 55px;
            background-color: rgb(167, 130, 236);
            .nav-icon-2 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon2.png")
                    top/100% auto no-repeat;
            }
            .nav-text {
                .num {
                    color: #fff;
                }
                .state-2 {
                    color: #fff;
                    &::after {
                        display: none;
                    }
                }
            }
        }
        .active-3 {
            border-radius: 55px;
            background-color: rgb(108, 133, 250);
            .nav-icon-3 {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                margin-right: 20px;
                background: url("~@/assets/images/ant/map/nav_icon3.png")
                    top/100% auto no-repeat;
            }
            .nav-text {
                .num {
                    color: #fff;
                }
                .state-3 {
                    color: #fff;
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }
}
.case-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    z-index: 777;
    .case-modal-header {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70px;
        background-color: #f9f9f9;
        .arrow-icon {
            background: url("~@/assets/images/ant/map/arrow.png") top/100% auto
                no-repeat;
            width: 47px;
            height: 20px;
        }
        .arrow-icon-t {
            transform: rotate(180deg);
        }
    }
    .case-list {
        height: 700px;
        overflow: hidden;
        ul {
            padding: 30px;
            li {
                overflow: hidden;
                border: 2px solid rgba(190, 201, 249, 0.3);
                border-radius: 20px;
                background-color: rgb(255, 255, 255);
                box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
                width: 100%;
                padding: 25px;
                margin-bottom: 15px;
                position: relative;
                & > p {
                    width: 85%;
                    font-size: 36px;
                    color: rgb(45, 45, 45);
                    font-weight: bold;
                    span {
                        display: inline-block;
                        margin-right: 5px;
                        margin-left: 5px;
                    }
                }
                .attr {
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .attr-left {
                        display: flex;
                        align-items: center;
                        p {
                            font-size: 28px;
                            color: rgb(0, 0, 0);
                            margin-right: 30px;
                        }
                        .tag-list {
                            // margin-top: 15px;
                            display: flex;
                            align-items: center;
                            & > div {
                                border: 2px solid #c5d0ff;
                                background-color: #f2f7ff;
                                border-radius: 40px;
                                margin-right: 10px;
                                font-size: 24px;
                                color: rgb(67, 89, 187);
                                padding: 3px 20px;
                            }
                        }
                    }
                    .attr-right {
                        display: flex;
                        align-items: center;
                        img {
                            width: 29px;
                            height: 21px;
                            flex-shrink: 0;
                            margin-right: 15px;
                        }
                        span {
                            font-size: 28px;
                            color: rgba(45, 45, 45, 0.502);
                        }
                    }
                }
                .pic-list {
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    .pic-item {
                        img {
                            margin: 0 5px;
                            width: 198px;
                            height: 198px;
                            flex-shrink: 0;
                        }
                    }
                }
                .state-icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                }
                .yqy {
                    background: url("~@/assets/images/ant/map/yqy.png") top/100%
                        auto no-repeat;
                    width: 118px;
                    height: 41px;
                }
                .ywg {
                    background: url("~@/assets/images/ant/map/ywg.png") top/100%
                        auto no-repeat;
                    width: 118px;
                    height: 41px;
                }
                .sgz {
                    background: url("~@/assets/images/ant/map/sgz.png") top/100%
                        auto no-repeat;
                    width: 118px;
                    height: 41px;
                }
            }
        }
        .not-data {
            margin-top: 30px;
            text-align: center;
            font-size: 24px;
            height: 100%;
        }
    }
    .upward {
        animation: moveTop 0.4s ease forwards;
    }
    .downward {
        animation: moveBottom 0.4s ease forwards;
    }
}
.tips {
    position: fixed;
    z-index: 99999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.774);
    display: flex;
    align-items: center;
    justify-content: center;
    .tips_warp {
        width: 500px;
        height: 200px;
        background: #fff;
        border-radius: 20px;
        .tips_title {
            width: 100%;
            font-size: 36px;
            font-weight: 700;
            height: 80px;
            border-bottom: 1px solid #f5f5f5;
        }
        div {
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 28px;
            padding: 0 50px;
            box-sizing: border-box;
        }
    }
}
@keyframes moveTop {
    0% {
        height: 0px;
    }

    100% {
        height: 700px;
    }
}
@keyframes moveBottom {
    0% {
        height: 700px;
    }

    100% {
        height: 0px;
    }
}
</style>
